(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2649],{

/***/ 64684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Newspager_NewspagerProfile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/TitleUnderline.js
var TitleUnderline = __webpack_require__(46975);
// EXTERNAL MODULE: ./components/EmptyBlock.js + 1 modules
var EmptyBlock = __webpack_require__(80326);
// EXTERNAL MODULE: ./styles/modules/NewsStory.module.scss
var NewsStory_module = __webpack_require__(69466);
var NewsStory_module_default = /*#__PURE__*/__webpack_require__.n(NewsStory_module);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./store/ux.js
var ux = __webpack_require__(30807);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./store/auth.js
var auth = __webpack_require__(32505);
// EXTERNAL MODULE: ./components/Profile/AddContent.js
var AddContent = __webpack_require__(93045);
// EXTERNAL MODULE: ./components/Card.js + 2 modules
var Card = __webpack_require__(8939);
// EXTERNAL MODULE: ./lang/en.json
var en = __webpack_require__(64798);
// EXTERNAL MODULE: ./components/Typo.js
var Typo = __webpack_require__(23775);
// EXTERNAL MODULE: ./store/alert.js
var store_alert = __webpack_require__(74703);
;// CONCATENATED MODULE: ./components/Profile/Alerts.js

















var resultsPerPage = 3;
var Alerts = function(param) {
    var data = param.data, empty = param.empty;
    var isAuthorized = (0,es/* useSelector */.v9)(auth/* authSelector */.aF).isAuthorized;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)([]), resultsToShow = ref[0], setResultsToShow = ref[1];
    var ref1 = (0,react.useState)(false), loadMoreActive = ref1[0], setLoadMoreActive = ref1[1];
    var ref2 = (0,react.useState)(data), stories = ref2[0], setStories = ref2[1];
    var ref3 = (0,react.useState)(resultsPerPage), next = ref3[0], setNext = ref3[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        setStories(data);
        loopWithSlice(resultsPerPage);
    }, [
        data
    ]);
    var holdingResults = [];
    var loopWithSlice = function(end) {
        var slicedResults = data === null || data === void 0 ? void 0 : data.slice(0, end);
        holdingResults = slicedResults ? (0,_to_consumable_array/* default */.Z)(holdingResults).concat((0,_to_consumable_array/* default */.Z)(slicedResults)) : null;
        setResultsToShow(holdingResults);
        if (end >= (stories === null || stories === void 0 ? void 0 : stories.length)) {
            setLoadMoreActive(false);
        } else {
            setLoadMoreActive(true);
        }
    };
    var handleRemovePopup = function(id) {
        dispatch((0,ux/* handleShowPopup */.YF)());
        dispatch((0,ux/* setPopupConfig */.iH)({
            onConfirm: function() {
                return handleRemoveConfirm(id);
            },
            onCancel: handleRemoveCancel,
            title: "Delete News alert?",
            confirmTitle: "Confirm",
            cancelTitle: "Cancel"
        }));
    };
    var handleRemoveConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch((0,ux/* setPopupLoading */.BI)(true));
                        return [
                            4,
                            dispatch((0,store_alert/* removeAlert */.JU)(id))
                        ];
                    case 1:
                        _state.sent();
                        dispatch((0,ux/* setPopupLoading */.BI)(false));
                        dispatch((0,ux/* handleHidePopup */.Zi)());
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRemoveConfirm(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRemoveCancel = function() {
        dispatch((0,ux/* handleHidePopup */.Zi)());
    };
    var handleAddNewsAlert = function() {
        router.push("".concat(router.asPath, "/news-alerts")).then(function() {
            return window.scrollTo(0, 0);
        });
    };
    var handleLoadMore = function() {
        var nextNum = next + resultsPerPage;
        loopWithSlice(nextNum);
        setNext(nextNum);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleUnderline/* default */.Z, {
                className: "mb-m",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
                        Tag: "h2",
                        variant: "eyebrow",
                        children: en/* profile.news_alerts.title */.N5.RA.TN
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (NewsStory_module_default()).addBtnWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddContent/* default */.Z, {
                            data: {
                                direction: "row",
                                label: en/* profile.news_alerts.button */.N5.RA.LI,
                                onClick: handleAddNewsAlert,
                                reverted: true,
                                blue: true,
                                labelHideMob: true
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-l",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (NewsStory_module_default()).newsStory,
                        children: resultsToShow === null || resultsToShow === void 0 ? void 0 : resultsToShow.slice(0, 5).map(function(param, key) {
                            var title = param.title, body = param.body, date = param.date, publisher = param.publisher, slug = param.slug, id = param.id;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                title: title,
                                body: body,
                                date: date,
                                source: publisher,
                                link: "/news-alerts/".concat(slug),
                                onRemove: isAuthorized && handleRemovePopup,
                                cta: "Read more",
                                id: id
                            }, "SingleCard-item-".concat(key));
                        })
                    }),
                    (resultsToShow === null || resultsToShow === void 0 ? void 0 : resultsToShow.length) < 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyBlock/* default */.Z, {
                        title: empty.title
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Profile_Alerts = (Alerts);

// EXTERNAL MODULE: ./styles/modules/MediaCoverage.module.scss
var MediaCoverage_module = __webpack_require__(30730);
var MediaCoverage_module_default = /*#__PURE__*/__webpack_require__.n(MediaCoverage_module);
// EXTERNAL MODULE: ./store/company/coverage.js
var coverage = __webpack_require__(57202);
// EXTERNAL MODULE: ./components/Profile/MissedCoverage.js
var MissedCoverage = __webpack_require__(16111);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Button.js + 2 modules
var Button = __webpack_require__(44217);
;// CONCATENATED MODULE: ./components/Profile/Coverages.js


















// This slice is server-rendered and indexed, so it must come out of the first
// render, not an effect. 45 is what clears 10k chars of text on a terse profile.
var Coverages_resultsPerPage = 45;
// long enough that a real headline survives intact
var titleLimit = 120;
function Coverages(param) {
    var data = param.data, total = param.total, companySlug = param.companySlug;
    var ref = (0,es/* useSelector */.v9)(auth/* authSelector */.aF), isAuthorized = ref.isAuthorized, isAdmin = ref.isAdmin, company = ref.company;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)(Coverages_resultsPerPage), shown = ref1[0], setShown = ref1[1];
    var coverages = data || [];
    var resultsToShow = coverages.slice(0, shown);
    var loadMoreActive = shown < coverages.length;
    // `total` is the API's full count; `coverages` is only the page we fetched
    var coverageTotal = total || coverages.length;
    var handleRemovePopup = function(id) {
        dispatch((0,ux/* handleShowPopup */.YF)());
        dispatch((0,ux/* setPopupConfig */.iH)({
            onConfirm: function() {
                return handleRemoveConfirm(id);
            },
            onCancel: handleRemoveCancel,
            title: "Delete Media coverage?",
            confirmTitle: "Confirm",
            cancelTitle: "Cancel"
        }));
    };
    var handleRemoveConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch((0,ux/* setPopupLoading */.BI)(true));
                        return [
                            4,
                            dispatch((0,coverage/* removeCoverage */.zM)(id))
                        ];
                    case 1:
                        _state.sent();
                        dispatch((0,ux/* setPopupLoading */.BI)(false));
                        dispatch((0,ux/* handleHidePopup */.Zi)());
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRemoveConfirm(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRemoveCancel = function() {
        dispatch((0,ux/* handleHidePopup */.Zi)());
    };
    var handleAddCoverage = function() {
        dispatch((0,ux/* handleShowSidescreen */.Co)("add-mediaCoverage"));
    };
    var handleEditCoverage = function(id) {
        dispatch((0,coverage/* editCoverage */.EC)(coverages.find(function(item) {
            return item.id === id;
        })));
        dispatch((0,ux/* handleShowSidescreen */.Co)("edit-mediaCoverage"));
    };
    var handleLoadMore = function() {
        return setShown(shown + Coverages_resultsPerPage);
    };
    var isOnOwnedProfile = companySlug === company;
    var isSomeCoverageNew = isOnOwnedProfile && coverages.some(function(param) {
        var status = param.status;
        return status === "new";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleUnderline/* default */.Z, {
                className: "mb-m",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
                        Tag: "h2",
                        variant: "eyebrow",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "data-nosnippet": true,
                            children: en/* profile.media_coverage.title */.N5.iT.TN
                        })
                    }),
                    isAuthorized && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MediaCoverage_module_default()).addBtnWrapper,
                        children: isAdmin ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AddContent/* default */.Z, {
                            data: {
                                direction: "row",
                                label: "Add ".concat(en/* profile.media_coverage.title */.N5.iT.TN),
                                onClick: handleAddCoverage,
                                reverted: true,
                                blue: true,
                                labelHideMob: true
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MissedCoverage/* default */.Z, {
                            className: (MediaCoverage_module_default()).tellUs
                        })
                    })
                ]
            }),
            isSomeCoverageNew && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MediaCoverage_module_default()).newCoverageNotification,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "More media coverage? Get you clever clogs. If you love this latest piece of exposure, you can pin it to the top of your Newspage so the whole world can see."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "As we charge nothing, or very little for the work we do, if ",
                            "you'd",
                            " like to buy the editorial team a couple of pints and a packet of Quavers, ",
                            "we'd",
                            " be extremely grateful. If you are struggling, however, as many small businesses and charities are, please DO NOT. ",
                            "We've",
                            " ",
                            "got your back."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://pay.newspage.media/b/6oE2bP5sif2qaNW5kp?s=pli",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "Send a tip here"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-l",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MediaCoverage_module_default()).mediaCoverage,
                        children: resultsToShow.map(function(param, key) {
                            var id = param.id, publisher = param.publisher, title = param.title, createdAt = param.createdAt, url = param.url, status = param.status;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                pretitle: publisher,
                                title: title,
                                publishedAt: createdAt,
                                link: url,
                                onRemove: isAuthorized && handleRemovePopup,
                                onEdit: isAdmin && handleEditCoverage,
                                editLabel: en/* profile.media_coverage.edit.button */.N5.iT.eP.button,
                                cta: "Read more",
                                id: id,
                                titleLimit: titleLimit,
                                status: status
                            }, "MediaCoverage-item-".concat(key));
                        })
                    }),
                    loadMoreActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        title: "Load more",
                        onClick: handleLoadMore
                    }),
                    coverageTotal > Coverages_resultsPerPage && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/".concat(companySlug, "/media-coverage"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: (MediaCoverage_module_default()).viewAll,
                            children: [
                                "View all ",
                                coverageTotal,
                                " pieces of media coverage"
                            ]
                        })
                    }),
                    coverages.length < 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyBlock/* default */.Z, {
                        title: en/* profile.media_coverage.placeholder_empty */.N5.iT.Xu
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Newspager/NewspagerCompany.js


var NewspagerCompany = function(param) {
    var coverages = param.coverages, coveragesTotal = param.coveragesTotal, stories = param.stories, news_stories = param.news_stories, companySlug = param.companySlug;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Coverages, {
            data: coverages,
            total: coveragesTotal,
            companySlug: companySlug
        })
    });
};
/* harmony default export */ var Newspager_NewspagerCompany = (NewspagerCompany);

;// CONCATENATED MODULE: ./components/Newspager/NewspagerProfile.js



var NewspagerProfile = function(param) {
    var company = param.company, coverages = param.coverages, coveragesTotal = param.coveragesTotal, stories = param.stories, alerts = param.alerts, news_stories = param.news_stories;
    var isCompanyJournalist = (company === null || company === void 0 ? void 0 : company.isJournalist) === true;
    if (isCompanyJournalist) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_Alerts, {
            data: alerts,
            title: news_stories.title,
            empty: {
                title: news_stories.placeholder_empty,
                link: {
                    href: "/",
                    title: news_stories.button
                }
            }
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Newspager_NewspagerCompany, {
            coverages: coverages,
            coveragesTotal: coveragesTotal,
            stories: stories,
            news_stories: news_stories,
            companySlug: company.slug
        });
    }
};
/* harmony default export */ var Newspager_NewspagerProfile = (NewspagerProfile);


/***/ }),

/***/ 6607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Remove; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Remove(props) {
    var fill = props.fill ? props.fill : "#f44336";
    var fillCross = props.fillCross ? props.fillCross : "#fafafa";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: fill,
                d: "M256 0C114.8 0 0 114.8 0 256s114.8 256 256 256 256-114.8 256-256S397.2 0 256 0zm0 0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: fillCross,
                d: "M350.3 320.1a21.3 21.3 0 11-30.2 30.2L256 286.2l-64.1 64a21.3 21.3 0 01-30.2 0 21.3 21.3 0 010-30l64.1-64.2-64-64.1a21.3 21.3 0 1130-30.2l64.2 64.1 64.1-64a21.3 21.3 0 1130.2 30L286.2 256zm0 0"
            })
        ]
    });
}


/***/ }),

/***/ 69466:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"NewsStory_page__qhooF","newsStoryContainer":"NewsStory_newsStoryContainer__UocNL","row":"NewsStory_row__cEOOs","headerWrapper":"NewsStory_headerWrapper__YCkBv","newsStory":"NewsStory_newsStory__cI1Gs","wrapper":"NewsStory_wrapper__XSClu","actionCard":"NewsStory_actionCard__TjrB_","singleCards":"NewsStory_singleCards__6q3qG","addBtnWrapper":"NewsStory_addBtnWrapper__HcuDg","loadMore":"NewsStory_loadMore__elpHv"};

/***/ })

}]);